import {TextAlignment, TextInput} from '@volkswagen-onehub/components-core';
import React, {useEffect, useState} from 'react';
import QuestionContentWrapper from '../components/QuestionContentWrapper';
import InputWrapperWithLabel from '../components/StyledInputWrapperWithLabel';
import TypographyBody from '../components/Typography/TypographyBody';
import TypographyHeading from '../components/Typography/TypographyHeading';
import useQuestionStore from '../store/navigation';
import {useResultStore} from '../store/responses';
import {QUESTIONIDS, Question} from '../types/question';
import {sendAnalyticPayload} from '../utils/analytic';
import {QuestionData} from '../constants/questions';
import {zodNameValidator} from '../constants/zod';
import useMediaQuery from '../hooks/useMediaQuery';

function QuestionZero(props: Question) {
  const {nextStepId, title} = props;
  const {setCurrentQuestion, currentQuestion} = useQuestionStore();
  const {updateQuestion, result} = useResultStore();
  const [errorMessages, setErrorMessages] = useState<string>('');
  const [name, setName] = React.useState(
    result[QUESTIONIDS.questionOneName] ?? '',
  );
  const [showIntro, setShowIntro] = useState(false);
  const {isMobile} = useMediaQuery();

  function handleChange(event: React.SyntheticEvent<HTMLInputElement>) {
    const validator = zodNameValidator;
    const target = event.target as HTMLInputElement;
    const inputValue = target?.value;
    if (!validator) return;
    const result = validator.safeParse(inputValue);

    if (!result.success) {
      setErrorMessages(result.error.errors[0]?.message);
    } else {
      setErrorMessages('');
    }
    setName(inputValue);
  }

  function onSubmit() {
    updateQuestion({
      id: QUESTIONIDS.questionOneName,
      value: name,
    });
    setCurrentQuestion(nextStepId);
    sendAnalyticPayload({
      process: {
        StepName: currentQuestion,
        StepNumber:
          QuestionData[currentQuestion]?.progressValue.toString() || '',
      },
      question: [
        {
          Question: currentQuestion || '',
          Answer: [
            {
              type: 'input_text',
              value: 'name',
            },
          ],
        },
      ],
    });
  }

  useEffect(() => {
    const validator = zodNameValidator;
    if (!validator) return;
    const result = validator.safeParse(name);

    if (result.success && name.length >= 2) {
      setShowIntro(true);
    } else {
      setShowIntro(false);
    }
  }, [name]);

  return (
    <QuestionContentWrapper
      disabled={!showIntro}
      title={title}
      handleClick={onSubmit}
      maxWidthContent={'400px'}
      maxWidthTitle={'530px'}
    >
      {' '}
      <form style={{...(isMobile && {width: '100%'})}}>
        <InputWrapperWithLabel variant={errorMessages ? 'error' : 'default'}>
          <TextInput
            name={'firstName'}
            appearance={'default'}
            type="text"
            placeholder="Please enter"
            value={name}
            onChange={handleChange}
            label="First Name"
            required
            defaultValue={result?.q1_name}
          />
          {errorMessages && (
            <TypographyBody size="small" color="#ff7474">
              {errorMessages}
            </TypographyBody>
          )}
        </InputWrapperWithLabel>
      </form>
      <div style={{marginTop: 60, transition: 'all 0.5s ease-out'}}>
        {showIntro && (
          <TypographyHeading textAlign={TextAlignment.center}>
            Great to meet you,
            <br />
            <TypographyBody bold textAlign={TextAlignment.center}>
              {name}!
            </TypographyBody>{' '}
          </TypographyHeading>
        )}
      </div>
    </QuestionContentWrapper>
  );
}

export default QuestionZero;
